import FilterCustomManager from './FilterCustomManager';
export { default as CustomResult } from './CustomResults';

export default FilterCustomManager;
